<template>
  <div class="main">
    <Nav />

    <section class="hero is-success is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">Welcome to Texas I-CAN!</h1>
          <h2 class="subtitle is-3">Initiatives for Children’s Activity and Nutrition</h2>
          <router-link class="button is-danger is-large" :to="{name: 'moduleList'}">
            <span>Find Activities for your Class</span>
          </router-link>
        </div>
      </div>
    </section>
    <section class="video">
      <div class="container">
        <div class="video-container">
          <iframe
            src="https://www.youtube-nocookie.com/embed/-FTF5NOoK9o"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
export default {
  components: {
    Nav,
    Footer
  }
};
</script>

<style lang='scss'>
.video {
  background: #222;
  padding: 40px 0;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%; /*16:9*/
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero.is-success {
  background: none;
  background-image: linear-gradient(
      to bottom,
      rgba(238, 200, 39, 0.2),
      rgba(238, 200, 39, 0.8)
    ),
    url("../img/running_boy.png");
  background-size: cover;
  background-position: right center;
}
</style>

